import React from "react";
import {updateQuestionInSurveyAtIdx} from "../../../../../slices/surveyEditorSlice";
import {connect, useDispatch} from "react-redux";
import {MAX_INPUT_NUMBER_VALUE, MIN_INPUT_NUMBER_VALUE} from "../../../../../utils/SurveyUtils";

function QuestionNumberEdit(props) {

    const dispatch = useDispatch();

    const handlePrefixChange = (event) => {
        const {questionData, idx} = props;
        let inputText = event.target.value;
        if(inputText || inputText === "") {
            let newQuestionData = JSON.parse(JSON.stringify(questionData));
            newQuestionData.options["prefix"] = event.target.value;
            dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));
        }
    };

    const handleSuffixChange = (event) => {
        const {questionData, idx} = props;
        let inputText = event.target.value;
        if(inputText || inputText === "") {
            let newQuestionData = JSON.parse(JSON.stringify(questionData));
            newQuestionData.options["suffix"] = event.target.value;
            dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));
        }
    };

    const handleMinValueChange = (event) => {
        const {questionData, idx} = props;
        let numberValue = event.target.value;
        let newQuestionData = JSON.parse(JSON.stringify(questionData));

        if (typeof numberValue === "undefined" || numberValue.localeCompare("") === 0) {
            newQuestionData.options["min"] = undefined;
        } else {
            numberValue = parseInt(numberValue);
            if (numberValue < MIN_INPUT_NUMBER_VALUE) numberValue = MIN_INPUT_NUMBER_VALUE;
            if (numberValue >= MAX_INPUT_NUMBER_VALUE) numberValue = MAX_INPUT_NUMBER_VALUE - 1;
            if (typeof newQuestionData.options["max"] !== "undefined" && numberValue >= newQuestionData.options["max"]) {
                numberValue = newQuestionData.options["max"] - 1;
            }
            newQuestionData.options["min"] = numberValue;
        }

        dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));
    };

    const handleMaxValueChange = (event) => {
        const {questionData, idx} = props;
        let numberValue = event.target.value;
        let newQuestionData = JSON.parse(JSON.stringify(questionData));

        if (typeof numberValue === "undefined" || numberValue.localeCompare("") === 0) {
            newQuestionData.options["max"] = undefined;
        } else {
            numberValue = parseInt(numberValue);
            if (numberValue <= MIN_INPUT_NUMBER_VALUE) numberValue = MIN_INPUT_NUMBER_VALUE + 1;
            if (numberValue > MAX_INPUT_NUMBER_VALUE) numberValue = MAX_INPUT_NUMBER_VALUE;
            if (typeof newQuestionData.options["min"] !== "undefined" && numberValue <= newQuestionData.options["min"]) {
                numberValue = newQuestionData.options["min"] + 1;
            }
            newQuestionData.options["max"] = numberValue;
        }

        dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));
    };

    return (
        <React.Fragment>
            <div className="questionaire__builder__col1 questionaire__builder__col1--flex">
                <div className="questionaire__builder__question__group">
                    <div className="questionaire__builder__question__subtitle">PREFIX</div>
                    <div className="questionaire__builder__question__inputs">
                        <div className="questionaire__builder__question__inputs__answear">
                            <input type="text"
                                   maxLength={56}
                                   className="questionaire__builder__question__inputs__answear__input"
                                   onChange={handlePrefixChange}
                                   value={props.questionData.options.prefix}
                            />
                        </div>
                    </div>
                </div>
                <div className="questionaire__builder__question__group">
                    <div className="questionaire__builder__question__subtitle">SUFFIX</div>
                    <div className="questionaire__builder__question__inputs">
                        <div className="questionaire__builder__question__inputs__answear">
                            <input type="text"
                                   maxLength={56}
                                   className="questionaire__builder__question__inputs__answear__input"
                                   onChange={handleSuffixChange}
                                   value={props.questionData.options.suffix}
                            />
                        </div>
                    </div>
                </div>
                <div className="questionaire__builder__question__group">
                    <div className="questionaire__builder__question__subtitle">MIN VALUE</div>
                    <div className="questionaire__builder__question__inputs">
                        <div className="questionaire__builder__question__inputs__answear">
                            <input type="number"
                                   min={MIN_INPUT_NUMBER_VALUE}
                                   max={MAX_INPUT_NUMBER_VALUE}
                                   className="questionaire__builder__question__inputs__answear__input"
                                   onChange={handleMinValueChange}
                                   value={Number(props.questionData.options.min).toString()}
                            />
                        </div>
                    </div>
                </div>
                <div className="questionaire__builder__question__group">
                    <div className="questionaire__builder__question__subtitle">MAX VALUE</div>
                    <div className="questionaire__builder__question__inputs">
                        <div className="questionaire__builder__question__inputs__answear">
                            <input type="number"
                                   min={MIN_INPUT_NUMBER_VALUE}
                                   max={MAX_INPUT_NUMBER_VALUE}
                                   className="questionaire__builder__question__inputs__answear__input"
                                   onChange={handleMaxValueChange}
                                   value={Number(props.questionData.options.max).toString()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default connect()(QuestionNumberEdit);